import { IconSymbol, IconSymbolName } from '@/components/ui/icon-symbol';
import { Colors } from '@/constants/theme';
import { StyleSheet } from 'react-native';
import { Text } from './text';
import { View } from './ui/tw-wrappers';

interface FeatureCardProps {
  icon: IconSymbolName;
  title: string;
  description: string;
}

export function FeatureCard({ icon, title, description }: FeatureCardProps) {
  return (
    <View className='md:flex-1' style={styles.container}>
      <View style={styles.header}>
        <View style={styles.iconContainer}>
          <IconSymbol name={icon} size={28} color={Colors.light.primary} />
        </View>
        <View style={styles.titleContainer}>
          <Text style={styles.title} type='subtitle'>
            {title}
          </Text>
        </View>
      </View>
      <View style={styles.content}>
        <Text style={styles.description}>{description}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {

    backgroundColor: '#fff',
    borderRadius: 24,
    padding: 24,
    minHeight: 200,
    borderWidth: 1,
    borderColor: '#E3E3E3',
    shadowColor: Colors.light.shadow,
    shadowOffset: { width: 4, height: 4 },
    shadowOpacity: 1,
    shadowRadius: 0,
    elevation: 2,
    gap: 14,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 18,
  },
  titleContainer: {
    flex: 1,
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#F0F4FF',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    marginTop: 4,
    gap: 12,
  },
  title: {
    fontSize: 18,
    lineHeight: 28,
    fontWeight: '700',
    color: '#000',
  },
  description: {
    fontSize: 14,
    lineHeight: 24,
    color: '#666',
  },
});
